// payroll-misc-messages translations (Spanish catalog).
window.PlummeI18n.register('es', {
  'r1l.pension.org': 'Org. {org}',
  'r1l.pension.voucherInline': 'Justificante {voucher}',
  'r1l.pension.employeesInline': '{count} empleados',
  'r1l.run.salaryTo': 'Salario a {name}',
  'r1l.holiday.paidShort': 'Pago:',
  'r1l.overview.holidayPayShort': 'Vac.:',
  'r1l.dialogs.correctionHint': 'Usa el icono de corrección junto al importe para ajustar el pago, p. ej. si no hay suficiente dinero en la cuenta para pagarlo todo.',
  'r1l.shared.addAccount': '+ Añadir cuenta',
  'r1l.tax.agaNote': 'La cotización del empleador se paga de forma conjunta por periodo. La prima de pensión se incluye en el periodo en que realmente se pagó.',
  'r1l.tax.partialNote': 'Un pago parcial se reparte proporcionalmente entre la retención de impuestos y la cotización del empleador.',
  'r1l.tax.annulledNote': 'Los pagos anulados no se conservan en el balance de comprobación.',
  'r1l.employee.saved': 'Empleado guardado.',
});
